import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/userContext';

export const ShowNonScriptView = () => {
  const navigate = useNavigate();
  const { isMobile, nativeView } = useContext(UserContext);

  return (
    <div className="container-standard mt-5">
      <div className="mx-auto flex max-w-xl flex-col items-center rounded-[32px] bg-white px-6 py-10 text-center shadow-xl md:px-10 md:py-14">
        <img
          src="/no-active-prescription-illustration.png"
          alt="No active prescription"
          className="w-48 md:w-56"
        />

        <h2 className="mt-6 text-2xl font-bold text-primary-blue-500">
          No active prescriptions
        </h2>

        <p className="mt-3 text-base text-primary-blue-400">
          Prescribed products will appear here when you have active
          prescriptions.
        </p>

        <button
          type="button"
          onClick={() =>
            navigate('/non-script-range', {
              state: {
                needBreadcrumbs: true,
              },
            })
          }
          className="mt-6 w-full rounded-full bg-primary-blue-500 py-4 text-base text-white md:w-auto md:px-10"
        >
          Shop Our Non-Script Range
        </button>

        <button
          type="button"
          onClick={() =>
            isMobile || nativeView
              ? navigate('/contact-us/')
              : window.location.replace(
                  'https://monivearoad.com.au/contact-us/',
                )
          }
          className="mt-4 text-sm text-primary-blue-500"
        >
          Need help? <span className="underline">Contact us</span>
        </button>
      </div>
    </div>
  );
};
